<div class="flex items-center justify-between flex-wrap gap-3">
  <h2 class="text-2xl font-bold text-[color:var(--text-color)] tracking-tight">{{ 'report.title' | translate }}</h2>
  <div class="flex items-center gap-3">
    <button type="button" class="sport-filter-toggle-btn"
      [class.active]="showSportFilter() || selectedSportsCount() > 0" (click)="toggleSportFilterPanel()">
      <span>Filters ({{ selectedSportsCount() }})</span>
      <i class="pi text-[10px]" [class.pi-chevron-up]="showSportFilter()"
        [class.pi-chevron-down]="!showSportFilter()"></i>
    </button>
  </div>
</div>

<div *ngIf="!loading() && showSportFilter()" class="filter-panel mt-4">
  <div class="filter-row filter-row-first">
    <img src="assets/icons/filter.svg" class="filter-icon" alt="" />
    <div class="text-[15px] font-semibold text-gray-500 uppercase tracking-widest leading-tight">
      {{ 'report.filters' | translate }}
    </div>
  </div>
  <div class="filter-divider"></div>

  <div class="filter-row">
    <span class="filter-row-label">{{ 'report.period' | translate }}</span>
    <div class="filter-row-content">
      <bo-date-range-picker [startDate]="dateRange().startDate" [endDate]="dateRange().endDate"
        (dateRangeChange)="onPendingDateRangeChange($event)" />
      <div class="preset-row">
        <button type="button" class="preset-chip" [class.active]="activePreset() === '30d'" (click)="setPreset('30d')">
          {{ 'report.preset30d' | translate }}
        </button>
        <button type="button" class="preset-chip" [class.active]="activePreset() === '90d'" (click)="setPreset('90d')">
          {{ 'report.preset90d' | translate }}
        </button>
        <button type="button" class="preset-chip" [class.active]="activePreset() === '6m'" (click)="setPreset('6m')">
          {{ 'report.preset6m' | translate }}
        </button>
        <button type="button" class="preset-chip" [class.active]="activePreset() === '12m'" (click)="setPreset('12m')">
          {{ 'report.preset12m' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="filter-row">
    <span class="filter-row-label">{{ 'report.gender' | translate }}</span>
    <div class="filter-row-content flex flex-wrap gap-1.5">
      <button type="button" class="sport-chip" [class.active]="selectedGender() === 'all'" (click)="setGender('all')">
        {{ 'report.genderAll' | translate }}
      </button>
      <button type="button" class="sport-chip" [class.active]="selectedGender() === 'male'" (click)="setGender('male')">
        ♂ {{ 'report.genderMale' | translate }}
      </button>
      <button type="button" class="sport-chip" [class.active]="selectedGender() === 'female'" (click)="setGender('female')">
        ♀ {{ 'report.genderFemale' | translate }}
      </button>
      <span class="filter-note">{{ 'report.genderNote2' | translate }}</span>
    </div>
  </div>

  <div class="filter-row">
    <span class="filter-row-label">{{ 'report.level' | translate }}</span>
    <div class="filter-row-content flex flex-wrap gap-1.5">
      <button type="button" class="sport-chip" [class.active]="selectedLevel() === 'all'" (click)="setLevel('all')">
        {{ 'report.levelAll' | translate }}
      </button>
      <button type="button" class="sport-chip" [class.active]="selectedLevel() === '1'" (click)="setLevel('1')">
        {{ 'report.level1' | translate }}
      </button>
      <button type="button" class="sport-chip" [class.active]="selectedLevel() === '2'" (click)="setLevel('2')">
        {{ 'report.level2' | translate }}
      </button>
      <button type="button" class="sport-chip" [class.active]="selectedLevel() === '3'" (click)="setLevel('3')">
        {{ 'report.level3' | translate }}
      </button>
      <span class="filter-note">{{ 'report.levelNoteScale' | translate }}</span>
    </div>
  </div>

  <div class="filter-row">
    <span class="filter-row-label">{{ 'report.city' | translate }}</span>
    <div class="filter-row-content flex flex-wrap gap-1.5 items-center">
      <input
        type="text"
        class="city-filter-input"
        #cityFilter
        [value]="selectedCity()"
        [placeholder]="'report.cityPlaceholder' | translate"
        (keyup.enter)="setCity(cityFilter.value)"
        (blur)="cityFilter.value !== selectedCity() && setCity(cityFilter.value)"
      />
      <button type="button" class="sport-chip" *ngIf="selectedCity()" (click)="cityFilter.value = ''; setCity('')">
        {{ 'report.cityClear' | translate }} ✕
      </button>
    </div>
  </div>

  <div class="filter-row">
    <span class="filter-row-label">{{ 'report.sports' | translate }}</span>
    <div class="filter-row-content flex flex-wrap gap-1.5">
      <button class="sport-chip" [class.active]="pendingSports().length === 0" (click)="clearSportSelection()">
        <img src="assets/icons/sport/allsports.svg" class="sport-chip-icon" alt="" />
        {{ 'report.allSports' | translate }}
      </button>

      <div class="sport-divider"></div>

      <button *ngFor="let def of allSportDefs()" class="sport-chip" [class.active]="isDefSelected(def.sportId)"
        (click)="toggleSport(def.sportId)">
        <img [src]="'assets/icons/sport/' + def.slug + '.svg'" class="sport-chip-icon" alt="" />
        {{ def.name }}
      </button>
    </div>
  </div>

  <div class="filter-actions">
    <button type="button" class="filter-apply-btn" (click)="applyFilters()">
      <i class="pi pi-check text-[11px]"></i>
      {{ 'report.apply' | translate }}
    </button>
    <button type="button" class="filter-reset-btn" (click)="onReset()">
      <i class="pi pi-refresh text-[11px]"></i>
      {{ 'report.resetAll' | translate }}
    </button>
  </div>
</div>

<div *ngIf="!loading()" class="grid grid-cols-4 gap-4 max-[1100px]:grid-cols-2 max-[540px]:grid-cols-1 pt-3">

  <div class="stat-card card-orange">
    <div class="flex flex-col w-full gap-3">
      <div class="flex items-center justify-between">
        <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-widest">{{ 'report.totalUsers' | translate }}</div>
        <div class="w-1 h-9 rounded-lg flex items-center justify-center bg-[#FCA13B] flex-shrink-0">
          <img src="assets/layout/images/logo-bg-white.svg" class="stat-card-icon" alt="" />
        </div>
      </div>
      <div class="flex items-baseline gap-1.5">
        <span class="text-4xl font-extrabold text-[color:var(--text-color)] leading-none tracking-tight">{{ totalUsers() | number }}</span>
      </div>
      <div class="text-sm text-gray-500">{{ 'report.allAccounts' | translate }}</div>
      <div class="yoy-badge" *ngIf="yoyUsers() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'report.vsLastYear' | translate }}
      </div>
    </div>
  </div>

  <div class="stat-card card-teal">
    <div class="flex flex-col w-full gap-3">
      <div class="flex items-center justify-between">
        <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-widest">{{ 'report.eventsInPeriod' | translate }}</div>
        <div class="w-1 h-9 rounded-lg flex items-center justify-center bg-[#1F8554] flex-shrink-0">
          <img src="assets/icons/event.svg" class="stat-card-icon" alt="" />
        </div>
      </div>
      <div class="text-4xl font-extrabold text-[color:var(--text-color)] leading-none tracking-tight">
        {{ totalEvents() | number }} / {{ totalParticipants() | number}}
      </div>
      <div class="yoy-badge" *ngIf="yoyEvents() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'report.vsLastYear' | translate }}
      </div>
      <div class="yoy-badge" *ngIf="yoyParticipants() as trend" [ngClass]="'is-' + trend.tone">
        {{ trend.value > 0 ? '+' : '' }}{{ trend.value }}% {{ 'report.participantsVsLastYear' | translate }}
      </div>
      <div class="text-sm text-gray-500">{{ 'report.eventsCreatedLegend' | translate }}</div>
    </div>
  </div>

  <div class="stat-card card-amber">
    <div class="flex flex-col w-full gap-3">
      <div class="flex items-center justify-between">
        <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-widest leading-tight">
          {{ 'report.mostPopular' | translate }}
        </div>
        <div class="w-1 h-9 rounded-lg flex items-center justify-center bg-[#FF6B35] flex-shrink-0">
          <img src="assets/icons/trophy.svg" class="stat-card-icon" alt="" />
        </div>
      </div>
      <div class="flex items-center gap-2 text-2xl font-bold text-[color:var(--text-color)] leading-tight">
        <img *ngIf="mostPopularSport()?.iconUrl" [src]="mostPopularSport()!.iconUrl" class="sport-stat-icon" alt="" />
        {{ mostPopularSport()?.frLabel || '—' }}
      </div>
      <div class="text-sm text-gray-500">
        {{ mostPopularSport()?.totalEvents || 0 | number }} {{ 'report.eventsWord' | translate }} ·
        {{ mostPopularSport()?.totalParticipants || 0 | number }} {{ 'report.participantsWordLower' | translate }}
      </div>
    </div>
  </div>

  <div class="stat-card card-blue">
    <div class="flex flex-col w-full gap-3">
      <div class="flex items-center justify-between">
        <div class="text-[11px] font-semibold text-gray-500 uppercase tracking-widest">{{ 'report.averageAge' | translate }}</div>
        <div class="w-1 h-9 rounded-lg flex items-center justify-center bg-[#3B62FC] flex-shrink-0">
          <img src="assets/icons/kpi.svg" class="stat-card-icon" alt="" />
        </div>
      </div>
      <div class="text-4xl font-extrabold text-[color:var(--text-color)] leading-none tracking-tight">
        {{ averageAge() }}
      </div>
      <div class="text-sm text-gray-500">{{ 'report.yearsOld' | translate }}</div>
    </div>
  </div>
</div>

<div *ngIf="loading()" class="flex flex-col items-center justify-center py-16 gap-3 pt-3">
  <p-progressSpinner strokeWidth="3" styleClass="custom-spinner"></p-progressSpinner>
  <p class="text-sm text-gray-500">Loading analytics data…</p>
</div>

<div *ngIf="!loading()" class="flex flex-col gap-4 pt-3">

  <div class="grid grid-cols-2 gap-4 max-[900px]:grid-cols-1">

    <div class="chart-card">
      <div class="chart-card-header">
        <div class="flex flex-row justify-content-between">
          <div class="text-[15px] font-semibold text-[color:var(--text-color)] tracking-tight">{{ 'report.activityTitle' | translate }}</div>
          <div *ngIf="dateRange().startDate && dateRange().endDate"
            class="inline-flex items-center gap-1 mt-1.5 px-2 py-1.5 rounded-full text-[10px] font-semibold bg-[#F5A62326] border border-[#FCA13B] text-[#FCA13B]">
            <i class="pi pi-calendar text-[9px]"></i>
            <span>{{ dateRange().startDate | date:'dd/MM/yyyy' }} – {{ dateRange().endDate | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.activityNote' | translate }}</div>
      </div>
      <div class="chart-card-content">
        <div class="chart-card-visual">
          <div class="chart-card-donut">
            <p-chart *ngIf="userTypeChart() as c" type="doughnut" [data]="c.data" [options]="c.options" height="200px" width="200px" />
            <div class="absolute pointer-events-none text-center">
              <div class="text-2xl font-extrabold text-[color:var(--text-color)] tracking-tight">{{ totalUsers() | number }}</div>
              <div class="text-[9px] font-semibold text-gray-500 tracking-widest uppercase mt-0.5">{{ 'report.total' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="chart-card-legend">
          <ng-container *ngFor="let u of userTypeLegend()">
            <div class="grid items-center gap-2 text-[13px]" style="grid-template-columns: 8px 1fr auto auto">
              <span class="w-full h-2 flex-shrink-0" [style.background]="u.color"></span>
              <span class="text-gray-400">{{ u.label }}</span>
              <span class="text-[#FCA13B] font-semibold text-right min-w-[38px]">{{ u.pct }}%</span>
              <span class="text-[color:var(--text-color)] font-semibold text-right min-w-[36px]">{{ u.count | number }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="chart-card">
      <div class="chart-card-header">
        <div class="text-[15px] font-semibold text-[color:var(--text-color)] tracking-tight">{{ 'report.sportTitle' | translate }}</div>
        <span class="unknown-chip" *ngIf="unknownSport().count > 0">{{ 'report.notFilled' | translate: { count: unknownSport().count, share: unknownSport().share } }}</span>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.sportNote' | translate }}</div>
        <div class="reliability-note" *ngIf="fieldShare('sport') !== null">{{ 'report.reliability' | translate: { share: fieldShare('sport') } }}</div>
        <a class="reliability-link" routerLink="/analyse-croisee">{{ 'report.crossLink' | translate }}</a>
      </div>
      <div class="chart-card-content">
        <div class="chart-card-visual">
          <div class="chart-card-donut">
            <p-chart *ngIf="totalsChart() as c" type="doughnut" [data]="c.data" [options]="c.options" height="200px" width="200px" />
            <div class="absolute pointer-events-none text-center">
              <div class="text-2xl font-extrabold text-[color:var(--text-color)] tracking-tight">{{ activeSportsCount() | number }}</div>
              <div class="text-[9px] font-semibold text-gray-500 tracking-widest uppercase mt-0.5">{{ 'report.sportsWord' | translate }}</div>
            </div>
          </div>
        </div>
        <div class="chart-card-legend">
          <ng-container *ngFor="let item of legendItems()">
            <div *ngIf="item.hasData" class="grid items-center gap-2 text-[13px]" style="grid-template-columns: 8px 1fr auto auto">
              <span class="w-full h-2 flex-shrink-0" [style.background]="item.color"></span>
              <span class="flex items-center gap-1.5 text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap min-w-0">
                <img *ngIf="item.iconUrl" [src]="item.iconUrl" class="legend-sport-icon" alt="" />
                <span *ngIf="!item.iconUrl" 
                      class="legend-sport-icon flex items-center justify-center font-bold text-gray-500"
                      >?</span>
                {{ item.label }}
              </span>
              <span class="text-[#FCA13B] font-semibold text-right min-w-[38px]">{{ item.pct }}%</span>
              <span class="text-[color:var(--text-color)] font-semibold text-right min-w-[36px]">{{ item.count | number }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>

  <!-- Sport Participation Trends — revenue-chart style + interactive legend -->
  <div class="revenue-chart rounded-xl !p-5" *ngIf="eventsLineChart()">
    <div class="flex items-start justify-between mb-4">
      <div>
        <h2 class="revenue-chart-title text-xl font-semibold">{{ 'report.trendsTitle' | translate }}</h2>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.trendsNote' | translate }}</div>
      </div>
      <div class="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-teal-500/10 border border-teal-500/25 text-teal-400">
        <i class="pi pi-calendar text-[10px]"></i>
        <span>{{ activeUsers() | number }} active</span>
      </div>
    </div>

    <p-chart
      #trendChart
      *ngIf="eventsLineChart() as c"
      type="line"
      [data]="c.data"
      [options]="c.options"
      height="280px"
    />

    <!-- Legend: line+point symbol, synced with chart hover -->
    <div class="revenue-chart-legend">
      <ng-container *ngFor="let item of legendItems(); let i = index">
        <button
          *ngIf="item.hasData"
          class="legend-item"
          [class.legend-item--faded]="hoveredLegendIndex() !== null && hoveredLegendIndex() !== i"
          [class.legend-item--active]="hoveredLegendIndex() === i"
          (mouseenter)="onLegendHover(i)"
          (mouseleave)="onLegendLeave()"
        >
          <svg width="32" height="12" viewBox="0 0 32 12" xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
            <line x1="0" y1="6" x2="32" y2="6" [attr.stroke]="item.color" stroke-width="2" stroke-linecap="round" />
            <circle cx="16" cy="6" r="3.5" [attr.fill]="item.color" stroke="var(--surface-card)" stroke-width="1.5" />
          </svg>
          <img [src]="item.iconUrl" class="legend-sport-icon" alt="" />
          <span class="legend-item-label" [style.color]="hoveredLegendIndex() === i ? item.color : null">
            {{ item.label }}
          </span>
        </button>
      </ng-container>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-4 max-[900px]:grid-cols-1">
    <div class="chart-card">
      <div class="mb-4">
        <div class="text-[15px] font-semibold text-[color:var(--text-color)] tracking-tight">{{ 'report.ageTitle' | translate }}</div>
        <span class="unknown-chip" *ngIf="unknownAge().count > 0">{{ 'report.notFilled' | translate: { count: unknownAge().count, share: unknownAge().share } }}</span>
        <div class="reliability-note" *ngIf="fieldShare('dateOfBirth') !== null">{{ 'report.reliability' | translate: { share: fieldShare('dateOfBirth') } }}</div>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.ageNote' | translate }}</div>
      </div>
      <p-chart *ngIf="ageChart() as c" type="bar" [data]="c.data" [options]="c.options" height="280px" />
    </div>
    <!-- <div class="chart-card">
      <div class="mb-4">
        <div class="text-[15px] font-semibold text-[color:var(--text-color)] tracking-tight">{{ 'report.levelTitle' | translate }}</div>
        <span class="unknown-chip" *ngIf="unknownLevel().count > 0">{{ 'report.notFilled' | translate: { count: unknownLevel().count, share: unknownLevel().share } }}</span>
        <div class="reliability-note" *ngIf="fieldShare('sport') !== null">{{ 'report.reliability' | translate: { share: fieldShare('sport') } }}</div>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.levelNote' | translate }}</div>
      </div>
      <p-chart *ngIf="levelChart() as c" type="bar" [data]="c.data" [options]="c.options" height="260px" />
    </div> -->

    <div class="chart-card">
      <div class="mb-4">
        <div class="text-[15px] font-semibold text-[color:var(--text-color)] tracking-tight">{{ 'report.genderTitle' | translate }}</div>
        <span class="unknown-chip" *ngIf="unknownGender().count > 0">{{ 'report.notFilled' | translate: { count: unknownGender().count, share: unknownGender().share } }}</span>
        <div class="reliability-note" *ngIf="fieldShare('sex') !== null">{{ 'report.reliability' | translate: { share: fieldShare('sex') } }}</div>
        <div class="text-xs text-gray-500 mt-0.5">{{ 'report.genderNote' | translate }}</div>
      </div>
      <div class="flex items-center gap-6 max-[640px]:flex-col">
        <div class="relative flex-shrink-0 w-[200px] h-[200px] flex items-center justify-center overflow-hidden rounded-full">
          <p-chart *ngIf="globalGenderChart() as c" type="doughnut" [data]="c.data" [options]="c.options" height="200px" width="200px" />
          <div class="absolute pointer-events-none text-center">
            <div class="text-2xl font-extrabold text-[color:var(--text-color)] tracking-tight">{{ genderDistributionTotal() | number }}</div>
            <div class="text-[9px] font-semibold text-gray-500 tracking-widest uppercase mt-0.5">{{ 'report.total' | translate }}</div>
          </div>
        </div>
        <div class="flex-1 flex flex-col gap-1.5 min-w-0">
          <ng-container *ngFor="let g of globalGenderLegend()">
            <div *ngIf="g.count > 0" class="grid items-center gap-2 text-[13px]" style="grid-template-columns: 8px 1fr auto auto">
              <span class="w-full h-2 flex-shrink-0" [style.background]="g.color"></span>
              <span class="text-gray-400 overflow-hidden text-ellipsis whitespace-nowrap">{{ g.icon }} {{ g.label }}</span>
              <span class="text-[#FCA13B] font-semibold text-right min-w-[38px]">{{ g.pct }}%</span>
              <span class="text-[color:var(--text-color)] font-semibold text-right min-w-[36px]">{{ g.count | number }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

  </div>

</div>

<div *ngIf="!loading() && selectedSports().length > 0 && filteredItems().length === 0"
  class="flex flex-col items-center py-12 gap-3 text-gray-600">
  <i class="pi pi-inbox text-4xl"></i>
  <p class="text-sm">{{ 'report.noSports' | translate }}</p>
</div>